import { LoaderCircle } from "lucide-react";
import { Progress } from "@/components/ui/progress";

export const UploadOverlay = ({ uploading, progress, submitting }) => {
  if (!uploading && !submitting) return null;
  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/70 p-6 backdrop-blur-sm"
      role="status"
      aria-live="polite"
      data-testid="loading-overlay"
    >
      <div className="fade-up w-full max-w-sm rounded-3xl bg-white p-7 text-center shadow-2xl">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-600">
          <LoaderCircle className="h-7 w-7 animate-spin" />
        </div>
        <p className="font-heading text-lg font-bold text-slate-900" data-testid="loading-overlay-title">
          {submitting ? "Mengirim pengaduan..." : "Mengunggah lampiran..."}
        </p>
        <p className="mt-1 text-sm text-slate-500">
          {submitting ? "Mohon tunggu sebentar." : "Jangan tutup halaman ini hingga proses selesai."}
        </p>
        {!submitting && (
          <>
            <Progress value={progress} className="mt-5 h-2" />
            <p className="mt-2 text-xs font-semibold text-emerald-700" data-testid="upload-progress-text">{progress}%</p>
          </>
        )}
      </div>
    </div>
  );
};
